import { z } from 'zod';
export const agentConfigSchema = z.object({
    system_prompt: z.string().min(1).max(12000),
    user_prompt_template: z.string().max(12000).optional(),
    max_tokens: z.number().int().min(64).max(4000).optional(),
    output_mode: z.enum(['text', 'json']).optional(),
});
export const agentCreateSchema = z.object({
    project_id: z.string().uuid(),
    name: z.string().min(1).max(120),
    description: z.string().max(2000).optional(),
    enabled: z.boolean().optional(),
    config: agentConfigSchema,
});
export const agentUpdateSchema = agentCreateSchema.omit({ project_id: true }).partial();
export const agentsListQuerySchema = z.object({
    project_id: z.string().uuid(),
});
//# sourceMappingURL=agent.js.map